import React from 'react';
import LikesCommentsContainer from './../../../LikesAndComments/components/LikesCommentContainer';
import ProductDetails from './../ProductDetails/ProductDeatils';
import helpers from './../../utils/helper';
import Seperator from '../../seperator/seperator';

class ProductDscriptionContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            view: 'comment'
        }
    }

    changeView = (view) => {
        this.setState({
            view
        })
    }

    render() {
        const {view} = this.state;
        const {showProductDetails} = this.props;
        return (
            <div className="product-description-layout layoutStyle">
                {

                    !helpers.isMobile() &&
                    <div>
                        <div className="tab-container">
                            <label className={"product-details " + (view !== 'details' ? "active" : "")}
                                   onClick={this.changeView.bind(this, 'comments')}>COMMENTS
                            </label>
                            {showProductDetails &&
                            <label className={"product-details " + (view === 'details' ? "active" : "")}
                                   onClick={this.changeView.bind(this, 'details')}>PRODUCT DETAILS</label>}
                        </div>
                        {
                            view != 'details' ?
                                <div className="description-details" id="short-description">
                                    <LikesCommentsContainer
                                        userName={this.props.userName}
                                        loadMore={this.props.loadMore}
                                        userId={this.props.userId}
                                        originalSharedProjectGuid={this.props.originalSharedProjectGuid}/>
                                </div>

                                : showProductDetails && <ProductDetails
                                {...this.props.productDescriptionInDetails}
                                {...this.props.productDescriptionInDetails.moreDetails}
                                loadMore={this.props.loadMoreComments}/>
                        }
                    </div>
                } {
                helpers.isMobile() &&
                <div>
                    <Seperator/>
                    <div className="comment-conatiner-layout">

                        <span className="titles">Comments</span>


                        <div className="description-details" id="short-description">
                            <LikesCommentsContainer
                                userName={this.props.userName}
                                loadMore={this.props.loadMore}
                                userId={this.props.userId}
                                originalSharedProjectGuid={this.props.originalSharedProjectGuid}/>
                        </div>
                    </div>
                    <div className="marginBottom20">
                        {showProductDetails && <Seperator/>}
                    </div>
                    {showProductDetails &&
                    <div className="productDetails-conatiner-layout">
                        <label className="titles">
                            <strong style={{"fontWeight": "bold"}}>
                                Product Details
                            </strong>
                        </label>
                        <ProductDetails
                            {...this.props.productDescriptionInDetails}
                            {...this.props.productDescriptionInDetails.moreDetails}
                            loadMore={this.props.loadMoreComments}/>
                    </div>
                    }
                </div>
            }
            </div>)
    }
}

export default ProductDscriptionContainer;